













import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrLeftNav extends Vue {
  @Prop()
  private cState: any;
  /**
   * @description 跳转患者档案
   */
  private jumpPatientList() {
    this.$router.push({
      path: "/main/cdr/patient-list",
      query: {
        project_id: this.$route.query.project_id
      }
    });
  }
}
